import ModelResults from './ModelResultsContainer';

export default ModelResults;
